import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp: number;
}

export const isTokenValid = (token: string | null): boolean => {
  if (!token) return false;
  try {
    const { exp } = jwtDecode<JwtPayload>(token);
    return exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export const clearCredentials = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userName');
};
